
import Vue from 'vue';

import BaseIcon from '@/components/BaseIcon.vue';

export default Vue.extend({
  name: 'BaseInput',
  components: {
    BaseIcon,
  },
  props: {
    labelClasses: {
      type: String,
    },
    inputClasses: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: String,
    },
    accept: {
      type: String,
    },
    id: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['password', 'text', 'email', 'file', 'tel', 'number'].includes(value),
    },
  },
  data() {
    return {
      value: [],
      toLargeFiles: [],
      showFileAttachedModal: false,
    };
  },
  methods: {
    callback: function (e) {
      if (e.target.files && e.target.files.length <= 0) {
        return;
      }
      this.value = Array.from(this.value).concat(Array.from(this.removeToLargeFiles(e.target.files)));
      this.$emit('input', this.value);
    },
    removeFile: function (index) {
      const dataTransfer = new DataTransfer();

      for (let i = 0; i < this.value.length; i++) {
        if (i !== index) {
          dataTransfer.items.add(this.value[i]);
        }
      }

      this.value = dataTransfer.files;
      this.$emit('delete', this.value);
    },
    formatFileSize: function(fileSize) {
      let fileExtension = ['Bytes', 'KB', 'MB', 'GB'];
      let i = 0;
      while (fileSize>900){
        fileSize /= 1024;
        i++;
      }
      return (Math.round(fileSize*100)/100)+' '+fileExtension[i];
    },
    removeToLargeFiles: function(files) {
      const maxFileSize = 10000000;
      const dataTransfer = new DataTransfer();

      for (let i = 0; i < files.length; i++) {
        if (files[i].size <= maxFileSize) {
          dataTransfer.items.add(files[i]);
        }else {
          this.toLargeFiles.push({name: files[i].name, size: files[i].name});
        }
      }

      return dataTransfer.files;
    },
    clearToLargeFiles: function () {
      this.toLargeFiles = [];
    },
    closeFileAttachedModal() {
      this.showFileAttachedModal = false;
    },
  },
});
